import React, { useEffect } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';

export default function RelatedInvoicePopup({
    open,
    relatedInvoice,
    allRelatedInvoice,
    setOpen,
    setRelatedInvoice,
    setAllRelatedInvoice,
    setDisabledRelatedInvoice
}) {

    const handleClose = () => {
        setOpen(false);
    };

    const addRelatedInvoice = () => {
        setRelatedInvoice('');
        if (relatedInvoice && relatedInvoice.length > 0) {
            setAllRelatedInvoice([...allRelatedInvoice, relatedInvoice]);
        }
        handleClose();
    }

    useEffect(() => {
        if (allRelatedInvoice && allRelatedInvoice.length > 0) {
            setDisabledRelatedInvoice(true);
        }
    }, [allRelatedInvoice, setDisabledRelatedInvoice])

    return (
        <div>
            <Dialog open={open} fullWidth={true}
                maxWidth="xs" onClose={handleClose}>
                <DialogContent>
                    <TextField
                        autoFocus
                        margin="dense"
                        label="Ingrese factura relacionada"
                        fullWidth
                        variant="standard"
                        onChange={e => setRelatedInvoice(e.target.value)}
                        value={relatedInvoice}
                    />
                </DialogContent>
                <DialogActions style={{ justifyContent: "center" }}>
                    <Button variant="contained" size="small" onClick={addRelatedInvoice}>ACEPTAR</Button>
                    <Button variant="contained" size="small" color="error" onClick={handleClose}>CANCELAR</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}
